import axios from "axios";
import { db } from "@src/services/db";
import { useAuthStore } from "@src/stores/auth";
import { useChatSessionStore } from "@src/stores/chatSession";
import type ChatSession from "@src/types/ChatSession";
import type { Tag } from "@src/services/tags";

type SessionTagsUpdatedPayload = {
    session_id: number;
    tags: Tag[];
    action: "attach" | "detach" | "toggle" | string;
    tag_id: number;
    actor_id?: number;
};

async function applyTagsUpdate(payload: SessionTagsUpdatedPayload) {
    const sessionId = Number(payload.session_id);
    if (!sessionId) return;

    await db.sessions.update(sessionId, {
        tags: payload.tags,
        updated_at: Date.now(),
    } as any);
}

export function TagsUpdatedSessionListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".SessionTagsUpdatedEvent", async (event: SessionTagsUpdatedPayload) => {
            try {
                if (event.actor_id && auth.user?.id === event.actor_id) return;

                await applyTagsUpdate(event);

                if (sessionStore.selectedSession?.id === Number(event.session_id)) {
                    (sessionStore.selectedSession as any).tags = event.tags;
                }
            } catch (e) {
                console.error("❌ erro no listener SessionTagsUpdatedEvent", e);
            }
        });
}
